import Actions from "../../model/constant/actions"
import ReducerUtils from "../../utils/ReducerUtils"


export default ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_FEEDS_SIGNED_URLS] : (state,action)=>action.status,
  [Actions.RETRIEVE_FEEDS_SIGNED_URLS]   : ()=>false
})
